// extracted by mini-css-extract-plugin
module.exports = {"dashboardUrl":"jgp-kAjZh","campaignShareModalContent":"jgp-noNRL","campaignLive":"jgp-12EbL","buttonNoMax":"jgp-3GVOY"};